import React, { useContext } from 'react';
import { Floor } from 'assets';
import { useRecoilValue } from 'recoil';
import { Typography, RegularButton } from 'fronton-react';
import { savedConfigurationCalculationState } from 'pages/saved-project-configuration/store/calculation';
import { LAMINATE_SERVICE_PATH, LEMANAPRO_LAMINATE_SERVICE_URL } from 'pages/common/consts/urls';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';
import { PriceCalculateContainer, Title } from './styles';

export const ServiceBanner = () => {
  const { data } = useContext(DataContext);
  const hasPresaleProps = Boolean(data?.presaleProps);
  const { services } = useRecoilValue(savedConfigurationCalculationState);
  const isValidService = services.length && services[0]?.priceMin;
  const price = isValidService ? Math.round(services[0].priceMin) : 0;

  if (!isValidService) {
    return null;
  }

  const handleButtonCalculateClick = () => {
    if (hasPresaleProps) {
      window.open(LEMANAPRO_LAMINATE_SERVICE_URL, '_blank', 'noopener noreferrer');
      return;
    }

    window.open(LAMINATE_SERVICE_PATH);
  };

  return (
    <div data-testid="service-banner">
      <Typography variant="h3">Поможем уложить</Typography>
      <PriceCalculateContainer>
        <Title>
          <Floor />
          <Typography size="body_accent" variant="m">
            Укладка ламината от {price} ₽
          </Typography>
        </Title>
        <RegularButton invert size="m" variant="primary" onClick={handleButtonCalculateClick}>
          Рассчитать
        </RegularButton>
      </PriceCalculateContainer>
    </div>
  );
};
